:host {
  display: inline-block;
}
button{
  cursor: pointer; 
  border: none;
  padding: 0px;
  margin: 0px;
  min-width: 15px;
  min-height: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}
svg{
  height:2em;
  width:2em;
  transition: all 300ms ease-in-out;
}

// FOCUS
button:focus-visible, button:hover{
  svg{
    color: var(--dnn-color-primary);
  }
}

// EXPANDED
:host([expanded]){
  svg{
    transform: rotate(90deg);
  }
}